/* eslint-disable no-console */
import Vue from "vue";
import { register } from "register-service-worker";

if (process.env.NODE_ENV === "production") {
  /**
   * Reload the page once when a chunk fails to load (stale deploy).
   * Uses a sessionStorage flag to allow exactly one auto-reload per session;
   * the user must manually refresh to retry after that.
   */
  const RELOAD_KEY = "chunk-reload-attempted";

  const handleChunkLoadError = () => {
    if (!sessionStorage.getItem(RELOAD_KEY)) {
      sessionStorage.setItem(RELOAD_KEY, "1");
      window.location.reload();
    }
  };

  // Catch dynamic import / chunk load failures (e.g. stale deploy serving HTML for JS)
  window.addEventListener("unhandledrejection", (event) => {
    const error = event?.reason;
    if (
      error &&
      (error.name === "ChunkLoadError" ||
        (error instanceof SyntaxError && error.message?.includes("Unexpected token '<'")))
    ) {
      handleChunkLoadError();
    }
  });

  register(`${process.env.BASE_URL}service-worker.js`, {
    ready() {
      Vue.$log.info(
        "App is being served from cache by a service worker.\n" + "For more details, visit https://goo.gl/AFskqB"
      );
    },
    registered() {
      Vue.$log.info("Service worker has been registered.");
    },
    cached() {
      Vue.$log.info("Content has been cached for offline use.");
    },
    updatefound() {
      Vue.$log.info("New content is downloading.");
    },
    updated(registration) {
      Vue.$log.info("New content is available; refreshing.");
      // Tell the new service worker to activate immediately, then reload
      // once it takes control to avoid serving stale chunks.
      if (registration.waiting) {
        registration.waiting.postMessage({ type: "SKIP_WAITING" });
      }
      navigator.serviceWorker.addEventListener("controllerchange", () => {
        window.location.reload();
      });
    },
    offline() {
      Vue.$log.info("No internet connection found. App is running in offline mode.");
    },
    error(error) {
      console.error("Error during service worker registration:", error);
    }
  });
}
